import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthService } from '@oneComply/core/services/auth.service';

function isPublicApiRoute(url: string): boolean {
  if (url.includes('/admin/')) {
    return false;
  }

  return url.includes('/reports');
}

function prepareRequest(req: HttpRequest<unknown>): HttpRequest<unknown> {
  if (req.body instanceof FormData) {
    return req.clone({
      headers: req.headers.delete('Content-Type'),
    });
  }

  return req;
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  const preparedReq = prepareRequest(req);

  if (!token || isPublicApiRoute(preparedReq.url)) {
    const publicReq = isPublicApiRoute(preparedReq.url)
      ? preparedReq.clone({
          headers: preparedReq.headers.delete('Authorization'),
        })
      : preparedReq;

    return next(publicReq);
  }

  return next(
    preparedReq.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    })
  );
};

